// frontend/src/pages/Socrates/components/common/SocratesCard/index.js

import React from 'react';
import styles from './SocratesCard.module.css';

const SocratesCard = ({ 
  children, 
  className = '', 
  onClick, 
  variant = 'default', // 'default', 'elevated', 'outlined'
  padding = 'default', // 'default', 'compact', 'spacious'
  ...props 
}) => {
  const cardClasses = [
    styles.card,
    styles[variant],
    styles[`padding-${padding}`],
    onClick ? styles.clickable : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div 
      className={cardClasses}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default SocratesCard;